"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _anyform = require("../anyform");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function SearchFormFilter(_ref) {
  var label = _ref.label,
    onUpdated = _ref.onUpdated;
  var _useValidatedForm = (0, _anyform.useValidatedForm)(),
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register;
  var onSubmit = function onSubmit(event) {
    event.preventDefault();
    var request = bind();
    onUpdated(event, request.search);
  };
  return /*#__PURE__*/_react["default"].createElement("form", {
    autoComplete: "off",
    noValidate: true,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "flex-end",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: true
  }, /*#__PURE__*/_react["default"].createElement(_anyform.AnyInput, {
    type: "text",
    name: "search",
    label: label,
    register: register
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    type: "submit",
    color: "secondary",
    size: "medium"
  }, (0, _core.translate)('buttons.search')))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(SearchFormFilter);